var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7187 23.4376H1.56252V1.56256H11.7187C12.15 1.56256 12.4999 1.21253 12.4999 0.781323C12.4999 0.35012 12.1499 9.15527e-05 11.7187 9.15527e-05H0.781227C0.350026 9.15527e-05 0 0.350055 0 0.781323V24.2189C0 24.6501 0.350026 25.0001 0.781227 25.0001H11.7187C12.1499 25.0001 12.4999 24.6501 12.4999 24.2189C12.4999 23.7876 12.1499 23.4376 11.7187 23.4376Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7734 11.9548L19.3828 6.48679C19.0773 6.17819 18.5828 6.17897 18.2781 6.48679C17.9726 6.7946 17.9726 7.29458 18.2781 7.60239L22.3406 11.7235H6.25242C5.82115 11.7235 5.47119 12.0767 5.47119 12.5126C5.47119 12.9485 5.82122 13.3017 6.25242 13.3017H22.3406L18.2781 17.4228C17.9726 17.7314 17.9726 18.2306 18.2781 18.5384C18.5836 18.847 19.0781 18.847 19.3828 18.5384L24.7726 13.0704C25.0742 12.7665 25.0773 12.2579 24.7734 11.9548Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2c4ac47756dbc3639b96e49463b4efd5.svg";
export { ForwardRef as ReactComponent };